import React, { useEffect } from 'react'

//|import { PluckingRooster as PluckingRoosterOverlay } from './../../Overlays/PluckingRooster'
import { PluckingRooster as PluckingRoosterOverlay } from './../../Overlays/Overlays/PluckingRooster'



const RankingPluckingRooster = ({ data, isActiveWomensMode }) => {

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete");
        } catch (error) {}
    };

    useEffect(() => {
        LoadPage();
    }, []);


    return (
        <>
            {/* FONDO (Background) */}
            <div className='SelfieFan__Screen__QR__Background'>
                {isActiveWomensMode ? (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='SelfieFan__Screen__Selfie__Background__Image' alt="Fondo" />
                ) : (
                    <img src='/img/page/backgrounds/background.png' className='SelfieFan__Screen__Selfie__Background__Image' alt="Fondo" />
                )}
            </div>

            {/* CONTENEDOR DEL RANKING (Aquí aplicas tu centrado con clases) */}
            {/* <div className="ranking-screen-container"> */}
                {/* Al pasar 'data' directamente, el hijo recibe:
                    { subtype: "...", data: { ... } }
                    Y reaccionará igual que en el Overlay (mostrar, ocultar, mover).
                */}
            {/* </div> */}
            <PluckingRoosterOverlay data={data} />

            <footer className='SelfieFan__Screen__QR__Footer FooterCredits'>Hecho con ♥ por Interaktia | 2026</footer>
        </>
    );
};

export { RankingPluckingRooster };









// import { useEffect } from 'react'


// const RankingPluckingRooster = ({ data, isActiveWomensMode }) => {

//     const LoadPage = async () => {
//         try {
//             document.getElementById("root").classList.add("BodyComplete")
//         } catch (error) {
            
//         }
//     }

//     useEffect(() => {
//         LoadPage()
//     }, [])
    

//     return (
//         <>
//             <div className='SelfieFan__Screen__QR__Background'>
//                 {isActiveWomensMode ? (
//                     <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='SelfieFan__Screen__Selfie__Background__Image' />
//                 ) : isActiveWomensMode === false && (
//                     <img src='/img/page/backgrounds/background.png' className='SelfieFan__Screen__Selfie__Background__Image' />
//                 )}
//             </div>

//             {/* Aquí va el Ranking */}

//             <footer className='SelfieFan__Screen__QR__Footer FooterCredits'>Hecho con ♥ por Interaktia | 2026</footer>
//         </>
//     )
// }

// export { RankingPluckingRooster };